import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-4">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500 sm:mt-0">
            About
          </p>
        </div>

        <p className="text-xl md:mt-20 sm:mt-0">
          I am faizan ahmad.I am from najibabad uttar pradesh India.I have done my b.tech in
          computer sceince from uttaranchal university dehradun.I have 7 months experience in
          Frontend development using ReactJs.I have done training in mern and frontend from 
          different institute like Croma Campus and Techaltum Noida.
        </p>

        <br />

        <p className="text-xl">
          And after that I did stipend based internship in physiomatica for 6 months.
          i used to work in Xaltum Technology in Noida.My job was developed user interface reusable 
          component using Reactjs.I am honest ,selfmotivated and hardworking boy with positive attitude 
          towards my career and my life.This is all about me thanks.....
        </p>
      </div>
    </div>
  );
};

export default About;
